'use strict';

var y = require('yup');

function _interopNamespaceCompat(e) {
    if (e && typeof e === 'object' && 'default' in e) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var y__namespace = /*#__PURE__*/_interopNamespaceCompat(y);

const name = 'allowEmpty';
/**
 * Allow Empty on Numbers.
 */ y__namespace.addMethod(y__namespace.NumberSchema, name, function() {
    return this.transform((v)=>isNaN(v) ? undefined : v);
});
//# sourceMappingURL=allowEmpty.js.map
